"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formatter_1 = __importDefault(require("@powerednow/shared/modules/utilities/formatter"));
const constants_1 = require("@powerednow/shared/constants");
const Renderer_1 = __importDefault(require("../../classes/Renderer"));
class CustomerRenderData extends Renderer_1.default {
    async getFullName() {
        const site = await this.getSite() || await this.item.getMainSite();
        const contact = await site.getContact();
        return contact.getFullName();
    }
    async getSite() {
        const { jobSite, defaultSite } = this.args;
        const isWorkSheet = this.args.documentType === constants_1.DOCUMENT.TYPES_VALUES.WORKSHEET;
        const displaySiteDetails = isWorkSheet && jobSite && jobSite.data.use_on_job_sheets;
        return displaySiteDetails ? jobSite : defaultSite;
    }
    async getDocumentTemplateData() {
        if (this.item.data.is_nosupplier) {
            return {
                is_nosupplier: this.item.data.is_nosupplier,
                account_name: this.item.data.account_name,
                company: this.item.data.company,
                utr: this.item.data.utr,
                company_number: this.item.data.company_number,
            };
        }
        const registeredSite = await this.item.getRegisteredSite();
        const mainContactToAddress = await this.item.getMainContactToAddress();
        const mainAddress = await mainContactToAddress.getAddress();
        const registeredAddress = registeredSite ? await registeredSite.getAddress() : mainAddress;
        const country = await registeredAddress.getCountry();
        const site = await this.getSite() || await this.item.getMainSite();
        const address = await site.getAddress();
        const addressCountry = await address.getCountry();
        const isWorkSheet = this.args.documentType === constants_1.DOCUMENT.TYPES_VALUES.WORKSHEET;
        const { jobSite, plot } = this.args;
        const formattedAddress = address.getFormattedAddressLines(isWorkSheet ? plot : '');
        let formattedJobAddress = null;
        if (jobSite.data.type !== constants_1.CONTACT_TO_ADDRESS.TYPE.MAIN) {
            const siteAddress = jobSite ? await jobSite.getAddress() : null;
            formattedJobAddress = siteAddress ? siteAddress.getFormattedSiteAddress(plot) : null;
        }
        return {
            is_nosupplier: this.item.data.is_nosupplier,
            account_name: this.item.data.account_name,
            company: this.item.data.company,
            utr: this.item.data.utr,
            company_number: this.item.data.company_number,
            fullName: await this.getFullName(),
            address1: address.data.address1,
            address2: address.data.address2,
            addressMerged: formattedAddress,
            formattedJobAddress,
            city: address.data.city,
            state: address.data.state,
            county: address.data.county,
            country: address.data.country,
            countryName: addressCountry?.data.name || 'GB',
            countryId: addressCountry?.data.id || 234,
            postcode: address.data.postcode,
            registeredAddress: formatter_1.default.stringifyAddress({
                address: registeredAddress.data.getPureDataValues(),
                ...(country ? { country: country.data.name } : {}),
            }),
        };
    }
}
exports.default = CustomerRenderData;
//# sourceMappingURL=../../../../src/models/customer/renderData.js.map